"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var StringPart = /** @class */ (function () {
    function StringPart(props) {
        var _this = this;
        this.toPascalCase = function () {
            if (!_this.isTag) {
                return _this.value;
            }
            if (_this.value.indexOf('_') === -1) {
                return _this.value.toLowerCase();
            }
            var split = _this.value.split('_');
            var camelCase = split.map(function (element) {
                var lcElement = element.toLowerCase();
                return lcElement.charAt(0).toUpperCase() + lcElement.slice(1);
            }).join('');
            return camelCase.charAt(0).toLowerCase() + camelCase.slice(1);
        };
        this.value = props.value;
        this.isPlaceholder = props.isPlaceholder;
        this.content = props.content;
        this.isTag = props.isTag;
    }
    StringPart.prototype.toProperties = function () {
        return {
            value: this.value,
            isPlaceholder: this.isPlaceholder,
            isTag: this.isTag,
            content: this.content ? this.content.map(function (elem) { return elem.toProperties(); }) : null // tslint:disable-line:no-null-keyword
        };
    };
    return StringPart;
}());
exports.StringPart = StringPart;
